import React from 'react';
import moment from 'moment';
import { RenderRetailTableActionButtons } from '../../commons/tableActionButton/tableActionButton';
import { zoomTableActionsConfig } from '../../commons/zoomTable/zoomTableConfig';

const ztCustomFieldThFlex10 = 'zt-custom-th flex-10';
const ztCustomFieldTdFlex10 = 'zt-custom-td flex-10';

export const vehicleAvailabilityStatusEnums = {
  AVAILABLE: 'AVAILABLE',
  SOFT_BLOCKED: 'SOFT_BLOCKED',
  BLOCKED: 'BLOCKED'
};

const vehicleAvailabilityStatusEnumValues = {
  AVAILABLE: 'Available',
  SOFT_BLOCKED: 'Soft Blocked',
  BLOCKED: 'Blocked'
};

export const manageVehiclesTableConfig = {
  columns: [
    {
      Header: 'Vendor Type',
      headerClassName: ztCustomFieldThFlex10,
      sortable: false,
      className: ztCustomFieldTdFlex10,
      Cell: row => (
        <div className="l-row a-center">
          {row.original.vendorType ? row.original.vendorType : '--'}
        </div>
      )
    },
    {
      Header: 'Vendor Name',
      headerClassName: 'zt-custom-th flex-15',
      sortable: false,
      className: 'zt-custom-td flex-15',
      Cell: row => (
        <div>
          <p>{row.original.vendorName ? row.original.vendorName : '-'}</p>
          <p>{row.original.vendorCode ? row.original.vendorCode : '-'}</p>
        </div>
      )
    },
    {
      Header: 'Vehicle Type',
      headerClassName: ztCustomFieldThFlex10,
      sortable: false,
      className: ztCustomFieldTdFlex10,
      Cell: row => (
        <div className="l-row a-center">
          {row.original.ownerType === 'SELF' ? 'OWNED' : row.original.ownerType}
        </div>
      )
    },
    {
      Header: 'Owner Name',
      headerClassName: 'zt-custom-th flex-15',
      className: 'zt-custom-td flex-15',
      sortable: false,
      Cell: row => <div>{row.original.ownerName || '-'}</div>
    },
    {
      Header: 'Vehicle Number',
      headerClassName: 'zt-custom-th flex-15',
      className: 'zt-custom-td flex-15',
      sortable: false,
      Cell: row => <div>{row.original.vehicleNumber || '-'}</div>
    },
    {
      Header: 'Size (ft)',
      headerClassName: ztCustomFieldThFlex10,
      className: ztCustomFieldTdFlex10,
      sortable: false,
      Cell: row => <div>{row.original.size || '-'}</div>
    },
    {
      Header: 'Capacity (kg)',
      headerClassName: 'zt-custom-th flex-15',
      className: 'zt-custom-td flex-15',
      sortable: false,
      Cell: row => <div>{row.original.capacity || '-'}</div>
    },
    {
      Header: 'Status',
      headerClassName: ztCustomFieldThFlex10,
      className: ztCustomFieldTdFlex10,
      sortable: false,
      Cell: row => (
        <div>
          <p>{row.original.status || '-'}</p>
          {row.original.status === 'REJECTED' && <p>{row.original.remark}</p>}
        </div>
      )
    },
    {
      Header: 'Body Type',
      headerClassName: ztCustomFieldThFlex10,
      className: ztCustomFieldTdFlex10,
      sortable: false,
      Cell: row => <div>{row.original.vehicleBodyType || '-'}</div>
    },
    {
      Header: 'Purchase Year',
      headerClassName: 'zt-custom-th flex-15',
      className: 'zt-custom-td flex-15',
      sortable: false,
      Cell: row => (
        <div>
          {row.original.purchaseMonthAndYear &&
          moment(row.original.purchaseMonthAndYear) &&
          moment(row.original.purchaseMonthAndYear).format('MMM, YYYY')
            ? moment(row.original.purchaseMonthAndYear).format('MMM, YYYY')
            : '-'}
        </div>
      )
    },
    {
      Header: 'Availability Status',
      headerClassName: 'zt-custom-th flex-20',
      className: 'zt-custom-td flex-20',
      sortable: false,
      Cell: row => (
        <div>
          <p>
            {(row.original.vehicleAvailabilityStatus &&
              (row.original.vehicleAvailabilityStatus ===
              vehicleAvailabilityStatusEnums.SOFT_BLOCKED
                ? vehicleAvailabilityStatusEnumValues.SOFT_BLOCKED
                : row.original.vehicleAvailabilityStatus)) ||
              '-'}
          </p>
          {row.original.vehicleAvailabilityStatus ===
            vehicleAvailabilityStatusEnums.SOFT_BLOCKED && (
            <p>{row.original.vehicleBlockingReason}</p>
          )}
        </div>
      )
    },
    {
      Header: 'Action',
      headerClassName: 'flex-25 zt-custom-th',
      className: 'flex-25',
      sortable: false,
      Cell: obj => (
        <RenderRetailTableActionButtons
          rowData={obj.original || {}}
          buttonConfig={
            zoomTableActionsConfig.MANAGE_VEHICLES_DASHBOARD.buttons
          }
        />
      )
    }
  ]
};

export const manageVehiclesTableActionConfig = {
  buttons: [
    {
      label: 'EDIT',
      labelOnly: true,
      hide: rowData => rowData && rowData.status === 'APPROVED',
      onClick: rowData => {
        if (
          zoomTableActionsConfig.MANAGE_VEHICLES_DASHBOARD.actions &&
          zoomTableActionsConfig.MANAGE_VEHICLES_DASHBOARD.actions.editVehicle
        ) {
          zoomTableActionsConfig.MANAGE_VEHICLES_DASHBOARD.actions.editVehicle(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    },
    {
      label: 'DELETE',
      labelOnly: true,
      hide: rowData => rowData && rowData.status !== 'CREATED',
      onClick: rowData => {
        if (
          zoomTableActionsConfig.MANAGE_VEHICLES_DASHBOARD.actions &&
          zoomTableActionsConfig.MANAGE_VEHICLES_DASHBOARD.actions.deleteVehicle
        ) {
          zoomTableActionsConfig.MANAGE_VEHICLES_DASHBOARD.actions.deleteVehicle(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    },
    {
      label: 'AVAILABILITY',
      labelOnly: true,
      hide: rowData => rowData && rowData.status !== 'APPROVED',
      onClick: rowData => {
        if (
          zoomTableActionsConfig.MANAGE_VEHICLES_DASHBOARD.actions &&
          zoomTableActionsConfig.MANAGE_VEHICLES_DASHBOARD.actions
            .updateVehicleAvailability
        ) {
          zoomTableActionsConfig.MANAGE_VEHICLES_DASHBOARD.actions.updateVehicleAvailability(
            rowData
          );
        }
      },
      style: {
        // Camel case all your known styles. x% width equals x% of 140px.
        width: '4rem',
        height: '4rem',
        margin: '0 0.5rem'
      }
    }
  ]
};

export const vehicleAvailabilityDropdownSizeNameValStrings = {
  nameKey: 'label',
  valKey: 'value'
};

export const legTypeList = [
  { label: 'FMLM', value: 'FMLM' },
  { label: 'MM', value: 'MM' }
];

export const partnerTypeList = [
  { label: 'VENDOR', value: 'VENDOR' },
  { label: 'RIVIGO', value: 'RIVIGO' }
];

export const vehicleStatusList = [
  { label: 'CREATED', value: 'CREATED' },
  { label: 'APPROVED', value: 'APPROVED' }
];

export const vehicleAvailabilitySelectOptions = [
  { label: 'Available', value: 'AVAILABLE' },
  { label: 'Soft Blocked', value: 'SOFT_BLOCKED' }
];

export const vehicleDataFieldAndErrorList = [
  {
    fieldName: 'ownerName',
    errorMessage: 'Please enter Owner Name'
  },
  {
    fieldName: 'vehicleNumber',
    errorMessage: 'Please enter Vehicle Number'
  },
  {
    fieldName: 'vehicleTypeId',
    errorMessage: 'Please select Vehicle Size'
  },
  {
    fieldName: 'vehicleBodyType',
    errorMessage: 'Please select Vehicle Body Type'
  },
  {
    fieldName: 'purchaseMonthAndYear',
    errorMessage: 'Please select Purchase Month and Year'
  },
  {
    fieldName: 'rcFrontS3Url',
    errorMessage:
      'Please upload RC Front Image (Both RC Front and Back images are required)'
  },
  {
    fieldName: 'rcBackS3Url',
    errorMessage:
      'Please upload RC Back Image (Both RC Front and Back images are required)'
  },
  {
    fieldName: 'vehicleFrontViewS3Url',
    errorMessage:
      "Please upload Vehicle Front Side Image (Vehicle's Front, Rear, Right and Left images are required)"
  },
  {
    fieldName: 'vehicleRearViewS3Url',
    errorMessage:
      "Please upload Vehicle Rear Side Image (Vehicle's Front, Rear, Right and Left images are required)"
  },
  {
    fieldName: 'vehicleRightViewS3Url',
    errorMessage:
      "Please upload Vehicle Right Side Image (Vehicle's Front, Rear, Right and Left images are required)"
  },
  {
    fieldName: 'vehicleLeftViewS3Url',
    errorMessage:
      "Please upload Vehicle Left Side Image (Vehicle's Front, Rear, Right and Left images are required)"
  }
];

export const vehicleAgeDataFieldAndErrorList = [
  {
    fieldName: 'pucDate',
    errorMessage: 'Please enter PUC Date.'
  },
  {
    fieldName: 'fitnessExpiryDate',
    errorMessage: 'Please enter fitness expiry date.'
  },
  {
    fieldName: 'permitExpiryDate',
    errorMessage: 'Please enter permit expiry date.'
  },
  {
    fieldName: 'insuranceExpiryDate',
    errorMessage: 'Please enter insurance expiry date.'
  },
  {
    fieldName: 'rtoDate',
    errorMessage: 'Please enter RTO Date.'
  },
  {
    fieldName: 'maxVehicleAgeInYears',
    errorMessage: 'Please enter valid maximum vehicle age in years.',
    condition: val => !!(val > 0 && val < 16),
    conditionFailedMessage:
      'Please enter valid maximum vehicle age between 1 - 15 years.'
  }
];

export const maximumVehicleExtraImagesCount = 3;

export const minimumVehicleDateTimeStamp = '441743400';
